type City = {
	code: string;
	name: string;
	alternateNames: string[];
};

export const citiesInfo: City[] = [
	// Banks with logos (prioritized)
	{
		code: "bengaluru",
		name: "Bangalore",
		alternateNames: ["Bengaluru", "Bangaluru", "BLR"],
	},
];

export const getCityCodeFromName = (name: string): string => {
	name = name.trim();
	return citiesInfo.find(bank => bank.name === name || bank.alternateNames.includes(name))?.code || "";
};

export const getCityNameFromCode = (code: string): string => {
	code = code.trim().toLowerCase();
	return citiesInfo.find(city => city.code === code)?.name || code;
};

export const getCityCodes = (): string[] => {
	return citiesInfo.map(c => c.code);
};
